module.exports = __webpack_public_path__ + "img/product_62.af38c57.webp";